import { createStore } from 'vuex'
import moment from 'moment';
import axios from 'axios';
import challengeModule from './challenges/index.js';
export default createStore({
  state: {
    loading: false,
    loops: [],
    start_date: moment().set({ year: 2026, month: 4, date: 25, hour: 7, minute: 0, second: 0 }),
    selected_challenge: '12_boucles',
    selected_boucle: 0,
    correspondance_challenge_name_uuid: {
      '12_boucles': 'Challenge 12 boucles',
      '12_boucles_relai': 'Challenge 12 boucles relai',
    }
  },
  modules: {
    challengeModule,
  },
  getters: {
    get_challenge_name: (state) => {
      return state.correspondance_challenge_name_uuid[state.selected_challenge];
    },
    getCurrentLoop: (state) => {
      let now = moment();
      let diff = now.diff(state.start_date, "hours") + 1;

      if (diff < 0) return 1;
      if (diff > 12) return 12;
      return diff;
    },
    getChallengeLoopById: (state) => () => {

      let requested_loop_id = state.selected_boucle;
      if (state.selected_challenge == '1_boucle' || state.selected_challenge == '3_boucles') {
        requested_loop_id += 1;
      }
      return state.loops.find(loop => loop.id == requested_loop_id);

    },
    getLoopListWithResults: (state) => {

      let loopListNotEmpty = state.loops.filter(loop => loop.runners.length > 0);

      let loopListWithResults = loopListNotEmpty.filter(loop => loop.runners.filter(runner => runner.course == state.correspondance_challenge_name_uuid[state.selected_challenge]).length > 0);


      return loopListWithResults;
    },
    hasStarted: (state) => {
      let now = moment();
      let has_started = now.isAfter(state.start_date);

      return has_started;
    },
    getLoopById: (state) => (id) => {
      return state.loops.find(loop => loop.id === id)
    },
    getChallengeByUuid: (state) => (uuid) => {
      switch (uuid) {
        case '12_boucles':
          return state.challengeModule.challenge_12_boucles;
        case '12_boucles_relai':
          return state.challengeModule.challenge_12_boucles_relai;
      }
    }
  },
  mutations: {
    setSelectedLoop(state, i) {
      state.selected_boucle = i;
    },
    setSelectedChallenge(state, uuid) {
      state.selected_challenge = uuid;
    },
    setLoop(state, data) {
      const loop = { filename: "Export-BWT26-" + data.id, last_modified: moment().toDate(), id: data.id, runners: [] };
      for (let i = 0; i < data.response.length; i++) {
        const runner = {
          dossard: parseInt(data.response[i][0]),
          nom: data.response[i][1],
          prenom: data.response[i][2],
          sexe: data.response[i][3],
          annee_naissance: parseInt(data.response[i][4]),
          club: data.response[i][5],
          categorie: data.response[i][6],
          course: data.response[i][7],
          temps: data.response[i][8],
          classement: parseInt(data.response[i][9]),
          classement_sexe: parseInt(data.response[i][10]),
          classement_categorie: parseInt(data.response[i][11]),
          abandon: data.response[i][12] == "O" ? true : false
        }
        loop.runners.push(runner);
        console.log(runner);
      }

      loop.runners.sort((a, b) => {
        // Parse the times using Moment.js
        const timeA = moment.duration(a.temps);
        const timeB = moment.duration(b.temps);

        // Compare the times
        if (timeA < timeB) {
          return -1;
        } else if (timeA > timeB) {
          return 1;
        } else {
          return 0;
        }
      });


      for (let i = 0; i < state.loops.length; i++) {
        if (state.loops[i].id == data.id) {
          state.loops[i] = loop;
          return;
        }
      }
      state.loops.push(loop);

    },
    setChallenge(state, data) {

      challengeModule.state.challenge_uuid = data.challenge_uuid;
      this.commit('challengeModule/buildChallenge', data.required_loops);
    },
    setRequiredLoops() {
    }

  },
  actions: {

    async fetchLoop({ commit }, payload) {
      const response = await axios.get('https://sportips.fr/api/v1/wtf-backyard/export/get.php?id=' + payload.id + '&y=26');

      commit('setLoop', { response: response.data, id: payload.id });
    },

    async fetchChallenge({ commit }, payload) {
      this.state.selected_challenge = payload.challenge_uuid;

      this.state.loops = [];
      switch (payload.challenge_uuid) {
        case '12_boucles':
          await this.dispatch('fetchRequiredLoops', { start: 1, end: 12 });
          break;
        case '12_boucles_relai':
          await this.dispatch('fetchRequiredLoops', { start: 1, end: 12 });
          break;
      }
      commit('setChallenge', { challenge_uuid: payload.challenge_uuid, required_loops: this.state.loops });
    },
    async fetchRequiredLoops({ commit }, range) {
      for (let i = range.start; i <= range.end; i++) {
        await this.dispatch('fetchLoop', { id: i });
      }
      commit('setRequiredLoops');
    }
  },
})
